import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import MobileFill from 'yoda-core-components/lib/assets/svg/MobileFill.svg';
import Mobile from 'yoda-core-components/lib/assets/svg/Mobile.svg';
import AppStoreIOs from 'yoda-core-components/lib/assets/svg/AppStoreIOs.svg';
import AppStoreGoogle from 'yoda-core-components/lib/assets/svg/AppStoreGoogle.svg';
import Device from 'yoda-core-components/lib/helpers/Device/Device';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import LinkConnected from '../../../Link/Link';
import analyticsAction from '../../../../actions/AnalyticsAction';
import * as styles from './index.css';
import config from '../../config';

const cx = classNames.bind(styles);

export class YodaGetTheApp extends Component {
    static defaultProps = {
        deviceType: {},
        enableFooterAppBanner: false,
        footerAppBannerDetails: { title: '', subtitle: '', ctaUrl: '', ctaLabel: '' },
        theme: null,
    };

    static propTypes = {
        deviceType: PropTypes.object,
        enableFooterAppBanner: PropTypes.bool,
        footerAppBannerDetails: PropTypes.object,
        actions: PropTypes.object.isRequired,
        theme: PropTypes.string,
    };

    constructor() {
        super();
        this.state = {
            showComponent: false,
            openInNewTab: false,
        };
        this.redirectToAppStore = this.redirectToAppStore.bind(this);
        this.redirectToMkt = this.redirectToMkt.bind(this);
        this.renderAppBanner = this.renderAppBanner.bind(this);
    }

    componentDidMount() {
        const nativeDeviceType = Device.findDeviceType();
        let appStoreUrl = null;
        const {
            PlayStoreUrls: { androidLink, iOSLink },
        } = config;

        if (!this.props.enableFooterAppBanner) {
            let displayAppLink = true;
            // Mobile by default
            if (this.props.deviceType.isDesktop) {
                this.setState({
                    showComponent: false,
                });
                return;
            }

            switch (nativeDeviceType) {
                case Device.TYPE.ANDROID:
                    appStoreUrl = androidLink;
                    break;
                case Device.TYPE.iOS:
                    appStoreUrl = iOSLink;
                    break;
                default:
                    displayAppLink = false;
                    break;
            }

            this.setState({
                showComponent: displayAppLink,
                appStoreUrl,
            });
        } else {
            const googleAppIcon = (
                <Icon
                    iconType="svg"
                    className="icon"
                    viewBox="0 0 135 40"
                    width="135px"
                    height="40px"
                >
                    <AppStoreGoogle />
                </Icon>
            );
            const iosAppIcon = (
                <Icon
                    iconType="svg"
                    className="icon"
                    viewBox="0 0 120 40"
                    width="120px"
                    height="40px"
                >
                    <AppStoreIOs />
                </Icon>
            );
            if (this.props.deviceType.isDesktop && this.props.theme === 'inFooterLinks') {
                this.setState({
                    openInNewTab: true,
                });
                return;
            }

            let appIcon = '';
            let openInNewTab = false;
            switch (nativeDeviceType) {
                case Device.TYPE.ANDROID:
                    appIcon = googleAppIcon;
                    appStoreUrl = androidLink;
                    openInNewTab = true;
                    break;
                case Device.TYPE.iOS:
                    appIcon = iosAppIcon;
                    appStoreUrl = iOSLink;
                    break;
                default:
                    break;
            }

            this.setState({
                appIcon,
                appStoreUrl,
                openInNewTab,
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (!this.props.enableFooterAppBanner) {
            return nextState.showComponent !== this.state.showComponent;
        }
        return true;
    }

    redirectToAppStore(event, url) {
        event.preventDefault();
        this.props.actions.triggerNavigationClick({
            linkName: 'footer:download from app banner',
            isReload: false,
        });
        return {
            url,
            openInNewTab: this.state.openInNewTab,
        };
    }

    redirectToMkt() {
        this.props.actions.triggerNavigationClick({
            linkName: 'footer:check out our apps',
            isReload: false,
        });
        return true;
    }

    /* eslint-disable jsx-a11y/no-static-element-interactions */
    renderAppBanner() {
        const { title = '', ctaUrl = '' } = this.props.footerAppBannerDetails;
        if (this.props.deviceType.isDesktop) {
            return (
                <div className="inline-block" data-automation-id="footer-get-app-desktop">
                    <LinkConnected
                        className={dt(['font-bold', 'text-small', 'text-black'])}
                        href={ctaUrl}
                        onClick={this.redirectToMkt}
                    >
                        <Icon
                            iconType="svg"
                            className={dt(['align-middle', 'inline-block'])}
                            viewBox="0 0 40 40"
                            width="40px"
                            height="40px"
                        >
                            <Mobile />
                        </Icon>
                        <span className={dt(['align-middle', 'inline-block', 'mr-3'])}>
                            {title}
                        </span>
                    </LinkConnected>
                </div>
            );
        }
        if (this.state.appIcon) {
            return (
                <div className={styles.appBannerWrapper} data-automation-id="footer-get-app-mobile">
                    <LinkConnected
                        className={dt(['text-center', 'block'])}
                        href={this.state.appStoreUrl}
                        onClick={(e) => this.redirectToAppStore(e, this.state.appStoreUrl)}
                    >
                        {this.state.appIcon}
                    </LinkConnected>
                </div>
            );
        }
        return '';
    }

    render() {
        if (this.props.enableFooterAppBanner) {
            return this.renderAppBanner();
        }
        const {
            DownloadApp: { label },
        } = config;
        return (
            <>
                {this.state.showComponent ? (
                    <div className={dt(['py-4', 'px-0'])}>
                        <div
                            className={dt([
                                'text-center',
                                'p-1.5',
                                'w-72',
                                'md:w-80',
                                'max-w-xs',
                                'text-black',
                                'mx-auto',
                                'bg-white',
                                'shadow-elevation1',
                                'border',
                                'border-solid',
                                'border-gray-70',
                            ])}
                        >
                            <button
                                className={dt(['text-base', 'text-gray-70'])}
                                data-automation-id="footer-get-button"
                                type="button"
                            >
                                <a
                                    href={this.state.appStoreUrl}
                                    data-automation-id="footer-get-link"
                                    className={dt(['text-gray-70', 'font-bold', 'text-base'])}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span className={dt(['mr-2'])}>
                                        <Icon
                                            iconType="svg"
                                            classNames="icon"
                                            viewBox="0 0 24 24"
                                            width="24px"
                                            height="24px"
                                            automationId="mobile-fill-icon"
                                        >
                                            <MobileFill />
                                        </Icon>
                                    </span>
                                    {label}
                                </a>
                            </button>
                        </div>
                    </div>
                ) : null}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(analyticsAction, dispatch),
});

export default connect(null, mapDispatchToProps)(YodaGetTheApp);
